import { render } from "./Footer.vue?vue&type=template&id=f61d1958"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__